<template>
    <div class="rating-labels">
        <div class="fuel badge me-1" :class="fuel.toLowerCase()" data-bs-toggle="tooltip" data-bs-placement="top" :title="fuelTooltipText">
            <i class="fas fa-gas-pump me-2 d-inline-block"></i>
            <p class="d-inline-block">{{ fuel }}</p>
        </div>
        <div class="wet badge me-1" data-bs-toggle="tooltip" data-bs-placement="top" :title="wetTooltipText">
            <i class="fas fa-cloud-showers me-2 d-inline-block"></i>
            <p class="d-inline-block text-white">{{ wet }}</p>
        </div>
        <div class="decibel badge" data-bs-toggle="tooltip" data-bs-placement="top" :title="decibelsTooltipText">
            <i class="fas fa-volume-down d-inline-block me-1"></i>
            <p class="d-inline-block">{{ decibels }}</p>
            <small v-if="noiseRating" class="d-inline-block">{{ noiseRating }}</small>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['fuel', 'wet', 'decibels', 'noiseRating'],
        data() {
            return {

            }
        },
        methods: {

        },
        computed: {
            fuelTooltipText() {
                return 'Having a high fuel efficiency rating of A on your tyres will give you more miles to the gallon and lower your CO2 emissions than a tyre with an E rating.';
            },
            wetTooltipText() {
                return 'There are 5 classes for rolling distance and wet grip, ranging from A to E. Having A rated tyres will give you shorter stopping distances in the wet and having E rated tyres will give you longer stopping distances.';
            },
            decibelsTooltipText() {
                return 'Noise levels are sorted into 3 classes, A, B or C. Noise ratings are based on decibels, tyres with a low noise level have between 67 and 71 dB and the highest have between 72 and 77 dB.';
            }
        }
    }
</script>

<style lang="scss" scoped>
    .rating-labels {
        div {
            font-size: 14px;
            color: #1a1a1a;
            padding: 5px 7px;
            cursor: default;
            @media(max-width: 768px) {
                font-size: 12px;
            }
            &.fuel {
                i, svg, p {
                    color: #222;
                }
                &.a {
                    background-color: #02983F;
                    i, svg, p {
                        color: #fff;
                    }
                }
                &.b {
                    background-color: #A1C716;
                }
                &.c {
                    background-color: #FEED01;
                }
                &.d {
                    background-color: #FCB900;
                }
                &.e, &.f, &.g {
                    background-color: #E40613;
                    i, svg, p {
                        color: #fff;
                    }
                }
            }
            &.wet {
                color: #fff;
                background-color: #005CAA;
            }
            &.decibel {
                background-color: #D3D3D3;
            }
            p {
                margin: 0;
                text-transform: uppercase;
            }
            small {
                font-size: 11px;
            }
        };
    }
</style>